import { isoLookups } from "./isoLookups";

const extractNamePercent = (country) => {
  const [name, percentage] = country.split("(");
  return [name.trim(), percentage ? +percentage.replace("%)", "") : ""];
};

const iso3Lookup = (country) => (isoLookups[country] ? isoLookups[country]["iso3"] : "");

const iso2Lookup = (country) => (isoLookups[country] ? isoLookups[country]["iso2"] : "");

const extractTradingPartnerInfo = (row) => {
  return {
    ...row,
    trading_partner_1_name_only: extractNamePercent(row["trading_partner_1_name"])[0],
    trading_partner_2_name_only: extractNamePercent(row["trading_partner_2_name"])[0],
    trading_partner_3_name_only: extractNamePercent(row["trading_partner_3_name"])[0],
    trading_partner_1_percentage: extractNamePercent(row["trading_partner_1_name"])[1],
    trading_partner_2_percentage: extractNamePercent(row["trading_partner_2_name"])[1],
    trading_partner_3_percentage: extractNamePercent(row["trading_partner_3_name"])[1],
    trading_partner_1_iso3: iso3Lookup(extractNamePercent(row["trading_partner_1_name"])[0]),
    trading_partner_2_iso3: iso3Lookup(extractNamePercent(row["trading_partner_2_name"])[0]),
    trading_partner_3_iso3: iso3Lookup(extractNamePercent(row["trading_partner_3_name"])[0]),
    trading_partner_1_iso2: iso2Lookup(extractNamePercent(row["trading_partner_1_name"])[0]),
    trading_partner_2_iso2: iso2Lookup(extractNamePercent(row["trading_partner_2_name"])[0]),
    trading_partner_3_iso2: iso2Lookup(extractNamePercent(row["trading_partner_3_name"])[0]),
  };
};

export default extractTradingPartnerInfo;
